import { render } from "./PosModal.vue?vue&type=template&id=aeae5c7a&ts=true"
import script from "./PosModal.vue?vue&type=script&lang=ts"
export * from "./PosModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__